import styled from "styled-components";
import { VIDEO_ELEMENT_HEIGHT } from "../Element";

const getBorderWidth = (active: boolean, isVideo: boolean) => {
  if (!active) return "1px";
  return isVideo ? "2px" : "3px";
};

const Container = styled.div<{ active: boolean; backgroundColor: string; borderColor: string; color: string; dragging: boolean; isVideo: boolean; activeElementsLength: number; smallElement: boolean; withVideos: boolean }>`
  position: absolute;
  height: ${props => (props.withVideos ? `${VIDEO_ELEMENT_HEIGHT}px` : "35px")};
  padding: ${props => (props.smallElement ? "0 2px" : "0 25px")};
  display: flex;
  align-items: center;
  border: 1px solid;
  border-color: ${props => props.borderColor};
  background: ${props => props.backgroundColor};
  border-width: ${props => getBorderWidth(props.active, props.isVideo)};
  border-radius: 8px;
  color: ${props => props.color};
  opacity: ${props => (props.dragging ? 0.7 : 1)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: ${props => (props.dragging ? 30 : 1)};

  &:hover {
    cursor: ${props => (props.dragging && props.activeElementsLength > 1 ? "ew-resize" : "pointer")};
  }
`;

export default Container;
